export const ID_TYPE = {
  NRIC_FIN: "NRIC_FIN",
  PASSPORT: "PASSPORT",
}

export const APPT_TYPE = {
  PHONE: "PHONE",
  VISIT: "VISIT",
  VIDEO: "VIDEO", // not in use yet
}

export const LANGUAGES = [
  { id: "EN", language: "English" },
  { id: "CN", language: "Chinese" },
  { id: "MA", language: "Malay" },
  { id: "TA", language: "Tamil" }
];

export const MODE_OF_CONTACT = {
  "PHONE": "PHONE",
  "EMAIL": "EMAIL",
}

// date format to use as id 
export const DATE_ID_FORMAT = "YYYYMMDD";

// Date format that display at the calendar component, 01 Jan 2023, Mon
export const DATE_FORMAT = "DD MMM YYYY, ddd";
// Timeslot format that display at slot selection, 09:00am
// And use this format for storing in redux also
export const TIME_SLOT_FORMAT = "hh:mma";
// Date format that pass to api
export const DATE_FORMAT_API = "YYYY-MM-DD";

export const CREATE_BOOKING_STATUS = {
  OK: "OK",
  HAVE_ANOTHER_CON: "HAVE_ANOTHER_CON",
  INVALID_DATA: "INVALID_DATA",
  TIME_SLOT_IS_FULL: "TIME_SLOT_IS_FULL",
  ERROR: "ERROR",
}

export const UPDATE_BOOKING_STATUS = {
  OK: "OK",
  DOES_NOT_HAVE_CON: "DOES_NOT_HAVE_CON",
  INVALID_DATA: "INVALID_DATA",
  TIME_SLOT_IS_FULL: "TIME_SLOT_IS_FULL",
  ERROR: "ERROR",
}
